module.exports = __webpack_public_path__ + "static/media/DaciaBlock-Light.c0c3b9d9.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/dacia-block/DaciaBlock-Light.eot
// module id = 762
// module chunks = 6